import { Base } from '@studiometa/js-toolkit';
import { addStyle } from '@studiometa/js-toolkit/utils';

/**
 * Splash component
 */
export default class Splash extends Base {
  /**
   * Component Configuration
   */
  static config = {
    name: 'Splash',
  };

  /**
   * Mounted hook
   */
  mounted() {
    document.scrollingElement.classList.add('is-splash-active');
    const origin = document.querySelector('#logo__splash');
    const target = document.querySelector('#logo__target svg');
    const targetPosition = target.getBoundingClientRect();
    const originPosition = origin.getBoundingClientRect();
    const scaleRatio = targetPosition.width / originPosition.width;
    const y = originPosition.y - targetPosition.top;

    setTimeout(() => {
      document.scrollingElement.classList.add('is-splash-leaving');
      addStyle(origin, {
        transform: `translateY(-${y}px) scale(${scaleRatio})`,
      });
    }, 1950);
  }
}
